import { HOMEWORK_STATUS } from '@/homework/values/homeworks.values';

export class WidgetTeacherHomework {
  id: number;
  sectionListId: number;
  classId: number;
  type: string;
  text: string;
  name: string;
  description: string;
  status: string;
  homeworkAssetInfo: any;
  homeworkDraftAssetInfo: any;
  answers?: any;
  grade: number;
  gradeName: string;
  section: any;
  sections: any[];
  courseId: number;
  boardGroup: string;
  responseDraft: WidgetTeacherHomework;
  feedbackDraft: WidgetTeacherHomework;
  constructor(data: any) {
    this.id = data.id || this.validateAttribute(data.section, 'id');
    this.sectionListId = data.sectionListId;
    this.type = this.obtainType(data);
    this.text = data.text || this.validateAttribute(data.section, 'text');
    this.name = data.name || this.validateAttribute(data.section, 'name');
    this.description = data.description;
    this.status = data.status;
    this.homeworkAssetInfo = data.homeworkAssetInfo;
    this.homeworkDraftAssetInfo = data.homeworkDraftAssetInfo;
    this.grade = data.grade;
    this.gradeName = data.gradeName;
    this.section = data.section;
    this.classId = data.classId;
    this.sections = data.sections || this.validateAttribute(data.section, 'sections');
    this.answers = data.answers;
    this.courseId = data.courseId;
    this.boardGroup = data.boardGroup;
    this.responseDraft = data.responseDraft;
    this.feedbackDraft = data.feedbackDraft;
  }

  private validateAttribute(section: any, attribute: string): any{
    return section && section[attribute] ? section[attribute] : null
  }

  private obtainType(data: any): string{
    if(data.status === HOMEWORK_STATUS.GRADED || data.status === HOMEWORK_STATUS.FINISHED
        || data.status === HOMEWORK_STATUS.NEW || data.status === HOMEWORK_STATUS.FEEDBACK_DRAFT){
      return data.type;
    } else {
      return this.validateAttribute(data.section, 'type') || data.type;
    }
  }
}